import { Component, Input, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/base-classes/componet-base';
import { OnlineMeeting } from '../../models/online-meeting';

@Component({
  selector: 'app-online-meeting-details',
  templateUrl: './online-meeting-details.component.html',
  styleUrls: ['./online-meeting-details.component.scss']
})
export class OnlineMeetingDetailsComponent extends ComponentBase implements OnInit {

  constructor() {
    super();
  }

  @Input() upcomingMeeting: OnlineMeeting;

  ngOnInit() {
  }

  IsMeetingEndsOnSameDay(meeting: OnlineMeeting) {
    if (new Date(meeting.start_time).setHours(0, 0, 0, 0) == new Date(meeting.end_time).setHours(0, 0, 0, 0)) {
      return true;
    }
    return false;
  }

  joinMeeting(joinUrl: string) {
    window.open(joinUrl, "_system");
  }

  copyJoinUrl(inputElement) {
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
  }

}
